import { sessaoFetchLoading, sessaoFetch } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function get (id) {
  return sessaoFetchLoading(`consig`, `/vendedor/GetEnvelopado/${id}`)
}
export async function getVendedores (dados) {
  return sessaoFetchLoading(`consig`, `/vendedor/ListarTodosPaginadoQueryEnvelopado?` + serialize(dados), 'GET')
}
export async function add (dados) {
  return sessaoFetchLoading(`consig`, `/vendedor/PostEnvelopado`, 'POST', dados)
}
export async function edit (dados) {
  return sessaoFetchLoading(`consig`, `/vendedor/PutEnvelopado`, 'PUT', dados)
}
export async function getComissaoVendedores (payload) {
  return sessaoFetchLoading(`consig`, `/vendedor/ComissaoVendedores?${serialize(payload)}`, 'GET', payload)
}
export async function getComissaoVendedoresNaoPaginado (payload) {
  return sessaoFetchLoading(`consig`, `/vendedor/ListarTodosNaoPaginado?${serialize(payload)}`, 'GET', payload)
}
export async function getVendedoresSemPaginacao (dados) {
  return sessaoFetchLoading(`consig`, `/vendedor/ListarTodosQueryEnvelopado?` + serialize(dados), 'GET')
}
export async function geraChave () {
  return sessaoFetch(`consig`, `/hash/gerarChave`, 'GET')
}
export async function addVinculandoUsuario (dados) {
  return sessaoFetchLoading(`consig`, `/vendedor/CriarVinculandoUsuario`, 'POST', dados)
}
export async function editVinculandoUsuario (dados) {
  return sessaoFetchLoading(`consig`, `/vendedor/EditarVinculandoUsuario`, 'PUT', dados)
}



// WEBPACK FOOTER //
// ./src/api/vendedor.js